import { Box, styled, Typography } from '@mui/material';
import ArrowRightIcon from 'app/components/Icons/arrow-right-icon';
import FileIcon from 'app/components/Icons/FileIcon';
import { grayDefault } from 'app/components/ThemeProvider/colors';

interface Props {
  title: string;
  onClick: VoidFunction;
}

const DocCard = (props: Props) => {
  const { title, onClick } = props;

  return (
    <Card onClick={onClick}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <IconBox>
          <FileIcon />
        </IconBox>
        <Typography fontWeight={600} fontSize={'16px'}>
          {title}
        </Typography>
      </Box>
      <ArrowRightIcon />
    </Card>
  );
};

const Card = styled(Box)({
  padding: '16px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'white',
  gap: '20px',
  boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.1)',
  borderRadius: '12px',
  cursor: 'pointer',
});

const IconBox = styled(Box)({
  display: 'flex',
  padding: '12px',
  backgroundColor: grayDefault,
  borderRadius: '12px',
  alignItems: 'center',
  justifyContent: 'center',
});

export default DocCard;
